export enum PRTabType  {
    basic = "basic",
    requestor = "requestor",
}

export enum LineItemTabType  {
    MATERIAL_MASTER = "MATERIAL_MASTER",
    ACCOUNT_DETAILS = "ACCOUNT_DETAILS",
    VENDOR_DETAILS = "VENDOR_DETAILS",
    RC_PROCESSING = "RC_PROCESSING",
    ATTACHMENTS = "ATTACHMENTS"
}

export enum PRRequestorType  {
    myself = "myself",
    behalf = "behalf",
}

export enum LineItemTabAction {
    VIEW = "VIEW",
    COPY = "COPY",
    EDIT = "EDIT",
    VIEWOREDIT = "VIEW / EDIT"
}

export enum ValidationType {
    VALIDATE = "BUYER_APPROVED",
    INVALIDATE = "BUYER_ENQUIRY"
}